import { Spacer as ChakraSpacer, SpacerProps } from "@chakra-ui/react";

export default function Spacer(props: SpacerProps): JSX.Element {
  return <ChakraSpacer {...props} />;
}
